export default __webpack_public_path__ + "static/media/Logo-instagramicon-transparent-PNG.d95141fd.png";